module.exports = __webpack_public_path__ + "img/anne_d.5164d817.png";